"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.numberTransformer = function (value) {
    if (typeof value !== 'string')
        return '';
    var matches = value.match(/\d+/g);
    if (!matches)
        return '';
    return matches.join('');
};
